import { Injectable } from '@angular/core';
import { EnvironmentConfig, returnUrlsIndex } from '../../config/environment.config';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private environmentConfig!: EnvironmentConfig;

  initializeConfig(redirectUrl: string) {
    this.environmentConfig = new EnvironmentConfig(redirectUrl);
  }

  public getSecureSiteApiUrl(): string {
    return this.environmentConfig.getSecureSiteApiUrl();
  }

  public getApiUrl(): string {
    return this.environmentConfig.getApiUrl();
  }

  public getLogonUrl(): string {
    return this.environmentConfig.getLogonUrl();
  }

  public getLogonRedirectUrl(): string {
    return this.environmentConfig.getLogonRedirectUrl();
  }

  public getUrlsEnvironments(): returnUrlsIndex {
    return this.environmentConfig.getAllUrlsIndexTransform();
  }

  public getPoid(): string {
    return this.environmentConfig.getPoid();
  }
  
  public setPoid(poid: string): void {
    return this.environmentConfig.setPoid(poid);
  }

  public getWatchlistUrl(): string {
    return this.environmentConfig.getWatchlistUrl()
  }
}
